import { render, staticRenderFns } from "./add-car.vue?vue&type=template&id=12b6a7bd&scoped=true&"
import script from "./add-car.vue?vue&type=script&lang=js&"
export * from "./add-car.vue?vue&type=script&lang=js&"
import style0 from "./add-car.vue?vue&type=style&index=0&id=12b6a7bd&scoped=true&lang=scss&"
import style1 from "./add-car.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b6a7bd",
  null
  
)

export default component.exports